import React from "react";
import AdminLogin from "./AdminLogin";

const AdminLoginWithQuery = props => (
  <AdminLogin title={"Admin Login"} {...props} />
);

export default AdminLoginWithQuery;
